
const Companys = {

    '': {
        companyID: 0,
        companyCode: 0,
        warehouseID: 0,
        companyName: "",
        companyBOMCode: 0,
        plantID: 0
    },

    'COMPANY_COD_WAREHOUSE_1-1': {
        companyID: 154,
        companyCode: 1,
        warehouseID: 1,
        companyName: "Fiat Automoveis S.A.",
        companyBOMCode: 161,
        plantID: 1
    },

    'COMPANY_COD_WAREHOUSE_191-1': {
        companyID: 167,
        companyCode: 191,
        warehouseID: 1,
        companyName: "JEEP Pernambuco",
        companyBOMCode: 191,
        plantID: 3
    },

    
    'COMPANY_COD_WAREHOUSE_10-10': {
        companyID: 168,
        companyCode: 10,
        warehouseID: 10,
        companyName: "FPT Fire - 010",
        companyBOMCode: 196,
        plantID: 1
    },
  
    'COMPANY_COD_WAREHOUSE_12-1': {
        companyID: 169,
        companyCode: 12,
        warehouseID: 1,
        companyName: "FPT Mecânica - 012",
        companyBOMCode: 196,
        plantID: 1
    },
  
    'COMPANY_COD_WAREHOUSE_595-1': {
        companyID: 170,
        companyCode: 595,
        warehouseID: 1,
        companyName: "FPT Campo Largo - 595",
        companyBOMCode: 595,  
        plantID: 2
    },
  
    'COMPANY_COD_WAREHOUSE_3-32': {
        companyID: 241,
        companyCode: 3,
        warehouseID: 32,
        companyName: "Mopar - P&A",
        companyBOMCode: 0,  
        plantID: 4
    } ,
  
    'COMPANY_COD_WAREHOUSE_630-0': {
        companyID: 243,
        companyCode: 630,
        warehouseID: 0,
        companyName: "Porto Real",
        companyBOMCode: 630,  
        plantID: 6
    } 
}

export function getCompanyIdsByPlantId(plantId: number): number[] {
    return Object.values(Companys)
        .filter((company) => company.plantID === plantId && company.companyID > 0)
        .map((company) => company.companyID);
}

export function getCompanyNameById(companyId: number): string {
    const company = Object.values(Companys).find((c) => c.companyID === companyId);
    return company ? company.companyName : String(companyId);
}

export default Companys;